import React from 'react';
import Loadable from 'react-loadable'

import DefaultLayout from './containers/DefaultLayout';

function Loading() {
  return <div>Loading...</div>;
}

const Dashboard = Loadable({
  loader: () => import('./views/Dashboard'),
  loading: Loading,
});

const CustomersContainer = Loadable({
  loader: () => import('./views/Pages/Customers'),
  loading: Loading,
});

const LogoutContainer = Loadable({
  loader: () => import('./views/Pages/Logout'),
  loading: Loading,
});



// https://github.com/ReactTraining/react-router/tree/master/packages/react-router-config
const routes = [
  { path: '/', exact: true, name: 'Home', component: DefaultLayout },
  { path: '/customers', name: 'Customers', component: CustomersContainer },
  { path: '/dashboard', name: 'Dashboard', component: Dashboard },
  { path: '/logout', name: 'Logout', component: LogoutContainer },
];

export default routes;



// WEBPACK FOOTER //
// ./src/routes.js